<button
  [type]="type"
  [style]="transition"
  [disabled]="disabled"
  [ngClass]="{
    'button--wide': wide,
    'button--thin': thin,
    'button--border': blueBorder,
    'button--loader': loading,
    'button--link': link,
    'button--filter': filter,
    'button--filter-main': filterMain,
    'button--filter-main--vermilion': filterMain && filterStyle === 'vermilion',
    'button--filter-main--transparent': filterMain && filterStyle === 'transparent',
    'button--filter-settings': filterSettings,
    'button--nude': nude,
    'button--selection': selection,
    active: active
  }"
  (click)="onClick()"
  class="button"
>
  <ng-content></ng-content>

  <ng-container *ngIf="!loading; else loader">
    <icon
      *ngIf="iconName || src"
      [width]="iconWidth"
      [height]="iconHeight"
      [src]="src"
      [name]="iconName"
      [color]="iconColor"
      [viewBox]="viewBox"
      class="button-icon"
    ></icon>

    <span
      *ngIf="buttonText"
      [translate]="buttonText"
      [translateParams]="buttonTextParams"
      class="button-text"
    >
    </span>
  </ng-container>

  <ng-template #loader>
    <div class="loader">
      <div class="loader__dot"></div>
      <div class="loader__dot loader__dot--2"></div>
      <div class="loader__dot loader__dot--3"></div>
    </div>
  </ng-template>
</button>
